"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP_HBS_PATH = exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED_HBS_PATH = exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED_HBS_PATH = exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_HBS_PATH = exports.ORGANIZATION_FAILED_PAD_ACH_HBS_PATH = exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_HBS_PATH = exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_HBS_PATH = exports.ORGANIZATION_STRIPE_RISK_REVIEW_HBS_PATH = exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED_HBS_PATH = exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK_HBS_PATH = exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_HBS_PATH = exports.ORGANIZATION_IMPORT_FAILED_HBS_PATH = exports.ORGANIZATION_IMPORT_COMPLETED_HBS_PATH = exports.ORGANIZATION_EXPORT_COMPLETED_HBS_PATH = exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_HBS_PATH = exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_HBS_PATH = exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH = exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_HBS_PATH = exports.ORGANIZATION_PAYOUT_FAILED_HBS_PATH = exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED_HBS_PATH = exports.ORGANIZATION_PAYOUT_CREATED_HBS_PATH = exports.ORGANIZATION_PAYOUT_PAUSED_HBS_PATH = exports.ORGANIZATION_BANK_ACCOUNT_UPDATE_HBS_PATH = exports.ORGANIZATION_AUCTION_CREATED_HBS_PATH = exports.ORGANIZATION_TICKETING_CREATED_HBS_PATH = exports.IMPACT_CHAIN_HBS_PATH = exports.TRIBUTE_DONATION_HBS_PATH = exports.GUEST_INFO_UPDATED_HBS_PATH = exports.GUEST_TICKET_HBS_PATH = exports.REMINDER_TICKETING_HBS_PATH = exports.DONATION_RENEWAL_HBS_PATH = exports.MEMBERSHIP_RENEWAL_HBS_PATH = exports.AUCTION_BID_CANCELLED_HBS_PATH = exports.AUCTION_NEW_TOP_BIDDER_HBS_PATH = exports.ORDER_SHIPPED_HBS_PATH = exports.READY_FOR_PICKUP_HBS_PATH = exports.AUCTION_BID_PLACED_HBS_PATH = exports.AUCTION_OUTBID_HBS_PATH = exports.AUCTION_NON_WINNER_HBS_PATH = exports.AUCTION_WINNER_HBS_PATH = exports.SEPA_DEBIT_NOTICE_HBS_PATH = exports.TRANSFER_IN_PROGRESS_HBS_PATH = exports.CAMPAIGN_PARTICIPATION_HBS_PATH = exports.TEAM_MEMBER_JOINED_HBS_PATH = exports.FUNDRAISER_HBS_PATH = exports.DONATION_HBS_PATH = exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH = exports.TICKETING_HBS_PATH = exports.ORGANIZATION_DAF_TO_CONFIRM_HBS_PATH = exports.DAF_DONATION_HBS_PATH = void 0;
exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_HBS_PATH = exports.ORGANIZATION_SATISFACTION_SURVEY_HBS_PATH = exports.ORGANIZATION_ORDER_RECEIVED_HBS_PATH = exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_HBS_PATH = exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR_HBS_PATH = exports.ORGANIZATION_DONATION_FORM_CREATED_HBS_PATH = exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_HBS_PATH = exports.ORGANIZATION_RECURRING_DONATION_CANCELLED_HBS_PATH = exports.ORGANIZATION_DONATION_RECEIVED_HBS_PATH = exports.DISPUTE_CREATED_CUSTOMER_HBS_PATH = exports.ORGANIZATION_PAGE_PUBLISHED_HBS_PATH = exports.ORGANIZATION_PAGE_CREATED_HBS_PATH = exports.ORGANIZATION_TICKET_TRANSFERRED_HBS_PATH = exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES_HBS_PATH = exports.ORGANIZATION_RADAR_EARLY_FRAUD_HBS_PATH = exports.ORGANIZATION_DISPUTE_CLOSED_HBS_PATH = exports.ORGANIZATION_DISPUTE_CREATED_HBS_PATH = exports.ORGANIZATION_MONTHLY_VISITOR_REPORT_HBS_PATH = exports.ORGANIZATION_WEEKLY_VISITOR_REPORT_HBS_PATH = exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED_HBS_PATH = exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED_HBS_PATH = exports.ORGANIZATION_RECEIVED_CREDIT_HBS_PATH = exports.ORGANIZATION_TREASURY_BETA_INVITATION_HBS_PATH = exports.ORGANIZATION_LOW_TREASURY_BALANCE_HBS_PATH = exports.ORGANIZATION_BENEFICIARY_ADDED_HBS_PATH = exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_HBS_PATH = exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED_HBS_PATH = exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_HBS_PATH = exports.ORGANIZATION_ISSUING_EXPENSE_FAILED_HBS_PATH = exports.ORGANIZATION_ISSUING_CARD_ACTIVATED_HBS_PATH = exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY_HBS_PATH = exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_HBS_PATH = exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_HBS_PATH = exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_HBS_PATH = exports.NEWSLETTER_THANK_YOU_HBS_PATH = exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_HBS_PATH = exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_HBS_PATH = exports.ORGANIZATION_SUPPORT_SERVER_ERROR_HBS_PATH = exports.ORGANIZATION_AUCTION_FAILED_PAYMENT_HBS_PATH = exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_HBS_PATH = exports.ORGANIZATION_AUCTION_CLOSED_HBS_PATH = exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_HBS_PATH = exports.ORGANIZATION_REFUND_REQUEST_HBS_PATH = exports.ORGANIZATION_ATTENDEE_CANCELLATION_HBS_PATH = exports.ORGANIZATION_TIPS_UPCOMING_EVENT_HBS_PATH = exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION_HBS_PATH = exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED_HBS_PATH = exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_HBS_PATH = exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_HBS_PATH = exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING_HBS_PATH = void 0;
exports.sendgridHtmlTemplate = exports.ORGANIZATION_PAGE_BUTTON_TEMPLATE_PATHS = exports.USER_DELETE_IMPORT_ERROR_HBS_PATH = exports.USER_DELETE_IMPORT_SUCCESS_HBS_PATH = exports.USER_CARD_EXPIRING_HBS_PATH = exports.USER_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH = exports.USER_FAILED_PAD_ACH_HBS_PATH = exports.USER_NPO_STARTER_INVITATION_HBS_PATH = exports.USER_INVITATION_REFUSED_HBS_PATH = exports.USER_INVITATION_SECOND_REMINDER_HBS_PATH = exports.USER_INVITATION_FIRST_REMINDER_HBS_PATH = exports.USER_MERGE_USERS_REQUEST_HBS_PATH = exports.USER_OWNERSHIP_TRANSFERRED_HBS_PATH = exports.USER_ADMIN_REVOKED_HBS_PATH = exports.USER_COLLABORATOR_APP_INVITE_HBS_PATH = exports.USER_ADMIN_ADDED_HBS_PATH = exports.USER_ORGANIZATION_INVITATION_HBS_PATH = exports.USER_ORGANIZATION_CREATED_HBS_PATH = exports.USER_NEW_DEVICE_HBS_PATH = exports.USER_EMAIL_CHANGE_CONFIRMED_HBS_PATH = exports.USER_CONTACT_EMAIL_CHANGED_HBS_PATH = exports.USER_PASSWORD_CHANGED_HBS_PATH = exports.USER_EMAIL_CHANGED_HBS_PATH = exports.USER_EMAIL_VERIFICATION_HBS_PATH = exports.USER_ASSISTANT_VERIFICATION_CODE_HBS_PATH = exports.USER_RESET_PASSWORD_HBS_PATH = exports.INVOICE_REMINDER_DONOR_HBS_PATH = exports.MEMBERSHIP_MEMBER_CARD_HBS_PATH = exports.MEMBERSHIP_NEW_CARD_DONOR_HBS_PATH = exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE_HBS_PATH = exports.RECEIPT_CANCELLED_DONOR_HBS_PATH = exports.ORGANIZATION_EMAIL_STATS_READY_HBS_PATH = exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST_HBS_PATH = exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_HBS_PATH = void 0;
const locales_1 = require("../enums/locales");
exports.DAF_DONATION_HBS_PATH = "daf/donation.hbs";
exports.ORGANIZATION_DAF_TO_CONFIRM_HBS_PATH = "organization/daf-to-confirm.hbs";
exports.TICKETING_HBS_PATH = "thank-you/ticketing.hbs";
exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH = "thank-you/sweepstakes-free-entry.hbs";
exports.DONATION_HBS_PATH = "thank-you/donation.hbs";
exports.FUNDRAISER_HBS_PATH = "thank-you/fundraiser.hbs";
exports.TEAM_MEMBER_JOINED_HBS_PATH = "thank-you/team-member-joined.hbs";
exports.CAMPAIGN_PARTICIPATION_HBS_PATH = "organization/campaign-participation.hbs";
exports.TRANSFER_IN_PROGRESS_HBS_PATH = "transfer-in-progress/ticketing.hbs";
exports.SEPA_DEBIT_NOTICE_HBS_PATH = "sepa/debit-notice.hbs";
exports.AUCTION_WINNER_HBS_PATH = "auction/thank-you-winner.hbs";
exports.AUCTION_NON_WINNER_HBS_PATH = "auction/thank-you-non-winner.hbs";
exports.AUCTION_OUTBID_HBS_PATH = "auction/outbid.hbs";
exports.AUCTION_BID_PLACED_HBS_PATH = "auction/bid-placed.hbs";
exports.READY_FOR_PICKUP_HBS_PATH = "fulfillment/ready-for-pickup.hbs";
exports.ORDER_SHIPPED_HBS_PATH = "fulfillment/order-shipped.hbs";
exports.AUCTION_NEW_TOP_BIDDER_HBS_PATH = "auction/new-top-bidder.hbs";
exports.AUCTION_BID_CANCELLED_HBS_PATH = "auction/bid-cancelled.hbs";
exports.MEMBERSHIP_RENEWAL_HBS_PATH = "membership/renewal.hbs";
exports.DONATION_RENEWAL_HBS_PATH = "donation/renewal.hbs";
exports.REMINDER_TICKETING_HBS_PATH = "reminder/ticketing.hbs";
exports.GUEST_TICKET_HBS_PATH = "guest/ticket.hbs";
exports.GUEST_INFO_UPDATED_HBS_PATH = "guest/info-updated.hbs";
exports.TRIBUTE_DONATION_HBS_PATH = "tribute/donation.hbs";
exports.IMPACT_CHAIN_HBS_PATH = "impact-chain/thank-you.hbs";
exports.ORGANIZATION_TICKETING_CREATED_HBS_PATH = "organization/ticketing-created.hbs";
exports.ORGANIZATION_AUCTION_CREATED_HBS_PATH = "organization/auction-created.hbs";
exports.ORGANIZATION_BANK_ACCOUNT_UPDATE_HBS_PATH = "organization/bank-account-update.hbs";
exports.ORGANIZATION_PAYOUT_PAUSED_HBS_PATH = "organization/payout-paused.hbs";
exports.ORGANIZATION_PAYOUT_CREATED_HBS_PATH = "organization/payout-created.hbs";
exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED_HBS_PATH = "organization/negative-payout-created.hbs";
exports.ORGANIZATION_PAYOUT_FAILED_HBS_PATH = "organization/payout-failed.hbs";
exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_HBS_PATH = "organization/next-day-payouts-enabled.hbs";
exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH = "organization/failed-recurring-card-payment.hbs";
exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_HBS_PATH = "organization/recurring-payment-never-made.hbs";
exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_HBS_PATH = "organization/recurring-payment-succeeded-after-failure.hbs";
exports.ORGANIZATION_EXPORT_COMPLETED_HBS_PATH = "organization/export-completed.hbs";
exports.ORGANIZATION_IMPORT_COMPLETED_HBS_PATH = "organization/import-completed.hbs";
exports.ORGANIZATION_IMPORT_FAILED_HBS_PATH = "organization/import-failed.hbs";
exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_HBS_PATH = "organization/stripe-verification-completed.hbs";
exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK_HBS_PATH = "organization/first-processed-payment-without-bank.hbs";
exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED_HBS_PATH = "organization/stripe-information-required.hbs";
exports.ORGANIZATION_STRIPE_RISK_REVIEW_HBS_PATH = "organization/stripe-risk-review.hbs";
exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_HBS_PATH = "organization/card-payment-capability-blocked.hbs";
exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_HBS_PATH = "organization/ownership-verification-helper.hbs";
exports.ORGANIZATION_FAILED_PAD_ACH_HBS_PATH = "organization/failed-pad-ach.hbs";
exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_HBS_PATH = "organization/custom-domain-succeeded.hbs";
exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED_HBS_PATH = "organization/custom-domain-failed.hbs";
exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED_HBS_PATH = "organization/webhook-auto-disabled.hbs";
exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP_HBS_PATH = "organization/referral-during-sign-up.hbs";
exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING_HBS_PATH = "organization/referral-during-onboarding.hbs";
exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_HBS_PATH = "organization/referral-first-referee-transaction.hbs";
exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_HBS_PATH = "organization/referral-first-referee-payout.hbs";
exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED_HBS_PATH = "organization/first-payment-received.hbs";
exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION_HBS_PATH = "organization/past-due-subscription.hbs";
exports.ORGANIZATION_TIPS_UPCOMING_EVENT_HBS_PATH = "organization/tips-upcoming-event.hbs";
exports.ORGANIZATION_ATTENDEE_CANCELLATION_HBS_PATH = "organization/attendee-cancellation.hbs";
exports.ORGANIZATION_REFUND_REQUEST_HBS_PATH = "organization/refund-request.hbs";
exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_HBS_PATH = "organization/check-in-manager-upcoming-event.hbs";
exports.ORGANIZATION_AUCTION_CLOSED_HBS_PATH = "organization/auction-closed.hbs";
exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_HBS_PATH = "organization/auction-organization-bid-submitted.hbs";
exports.ORGANIZATION_AUCTION_FAILED_PAYMENT_HBS_PATH = "organization/auction-failed-payment.hbs";
exports.ORGANIZATION_SUPPORT_SERVER_ERROR_HBS_PATH = "organization/support-server-error.hbs";
exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_HBS_PATH = "organization/newsletter-signup-notification.hbs";
exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_HBS_PATH = "organization/org-page-contact-message.hbs";
exports.NEWSLETTER_THANK_YOU_HBS_PATH = "newsletter/thank-you.hbs";
exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_HBS_PATH = "organization/nbctc-new-lead-signed-up.hbs";
exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_HBS_PATH = "organization/scheduled-email-confirmation.hbs";
exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_HBS_PATH = "organization/quickbooks-disconnected-notification.hbs";
exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY_HBS_PATH = "organization/issuing-card-on-the-way.hbs";
exports.ORGANIZATION_ISSUING_CARD_ACTIVATED_HBS_PATH = "organization/issuing-card-activated.hbs";
exports.ORGANIZATION_ISSUING_EXPENSE_FAILED_HBS_PATH = "organization/issuing-expense-failed.hbs";
exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_HBS_PATH = "organization/issuing-topup-succeeded.hbs";
exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED_HBS_PATH = "organization/issuing-reward-succeeded.hbs";
exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_HBS_PATH = "organization/financial-account-created.hbs";
exports.ORGANIZATION_BENEFICIARY_ADDED_HBS_PATH = "organization/beneficiary-added.hbs";
exports.ORGANIZATION_LOW_TREASURY_BALANCE_HBS_PATH = "organization/low-treasury-balance.hbs";
exports.ORGANIZATION_TREASURY_BETA_INVITATION_HBS_PATH = "organization/treasury-beta-invitation.hbs";
exports.ORGANIZATION_RECEIVED_CREDIT_HBS_PATH = "organization/received-credit.hbs";
exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED_HBS_PATH = "organization/outbound-payment-posted.hbs";
exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED_HBS_PATH = "organization/outbound-payment-failed.hbs";
exports.ORGANIZATION_WEEKLY_VISITOR_REPORT_HBS_PATH = "organization/weekly-visitor-report.hbs";
exports.ORGANIZATION_MONTHLY_VISITOR_REPORT_HBS_PATH = "organization/monthly-visitor-report.hbs";
exports.ORGANIZATION_DISPUTE_CREATED_HBS_PATH = "organization/dispute-created.hbs";
exports.ORGANIZATION_DISPUTE_CLOSED_HBS_PATH = "organization/dispute-closed.hbs";
exports.ORGANIZATION_RADAR_EARLY_FRAUD_HBS_PATH = "organization/radar-early-fraud.hbs";
exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES_HBS_PATH = "organization/insufficient-capabilities.hbs";
exports.ORGANIZATION_TICKET_TRANSFERRED_HBS_PATH = "organization/ticket-transferred-to-new-occurrence.hbs";
exports.ORGANIZATION_PAGE_CREATED_HBS_PATH = "organization/page-created.hbs";
exports.ORGANIZATION_PAGE_PUBLISHED_HBS_PATH = "organization/page-published.hbs";
exports.DISPUTE_CREATED_CUSTOMER_HBS_PATH = "dispute/created-customer.hbs";
exports.ORGANIZATION_DONATION_RECEIVED_HBS_PATH = "organization/donation-received.hbs";
exports.ORGANIZATION_RECURRING_DONATION_CANCELLED_HBS_PATH = "organization/recurring-donation-cancelled.hbs";
exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_HBS_PATH = "organization/subscription-amount-updated.hbs";
exports.ORGANIZATION_DONATION_FORM_CREATED_HBS_PATH = "organization/donation-form-created.hbs";
exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR_HBS_PATH = "subscription/amount-updated-donor.hbs";
exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_HBS_PATH = "subscription/payment-method-updated-donor.hbs";
exports.ORGANIZATION_ORDER_RECEIVED_HBS_PATH = "organization/order-received.hbs";
exports.ORGANIZATION_SATISFACTION_SURVEY_HBS_PATH = "organization/satisfaction-survey.hbs";
exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_HBS_PATH = "organization/individual-fundraising-outreach.hbs";
exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_HBS_PATH = "organization/desktop-completion-suggestion.hbs";
exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST_HBS_PATH = "organization/mailing-feedback-request.hbs";
exports.ORGANIZATION_EMAIL_STATS_READY_HBS_PATH = "organization/email-stats-ready.hbs";
exports.RECEIPT_CANCELLED_DONOR_HBS_PATH = "receipt/cancelled-donor.hbs";
exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE_HBS_PATH = "membership/members-only-not-eligible.hbs";
exports.MEMBERSHIP_NEW_CARD_DONOR_HBS_PATH = "membership/new-card-donor.hbs";
exports.MEMBERSHIP_MEMBER_CARD_HBS_PATH = "membership/member-card.hbs";
exports.INVOICE_REMINDER_DONOR_HBS_PATH = "invoice/reminder-donor.hbs";
exports.USER_RESET_PASSWORD_HBS_PATH = "user/reset-password.hbs";
exports.USER_ASSISTANT_VERIFICATION_CODE_HBS_PATH = "user/assistant-verification-code.hbs";
exports.USER_EMAIL_VERIFICATION_HBS_PATH = "user/email-verification.hbs";
exports.USER_EMAIL_CHANGED_HBS_PATH = "user/email-changed.hbs";
exports.USER_PASSWORD_CHANGED_HBS_PATH = "user/password-changed.hbs";
exports.USER_CONTACT_EMAIL_CHANGED_HBS_PATH = "user/contact-email-changed.hbs";
exports.USER_EMAIL_CHANGE_CONFIRMED_HBS_PATH = "user/email-change-confirmed.hbs";
exports.USER_NEW_DEVICE_HBS_PATH = "user/new-device.hbs";
exports.USER_ORGANIZATION_CREATED_HBS_PATH = "user/organization-created.hbs";
exports.USER_ORGANIZATION_INVITATION_HBS_PATH = "user/organization-invitation.hbs";
exports.USER_ADMIN_ADDED_HBS_PATH = "user/admin-added.hbs";
exports.USER_COLLABORATOR_APP_INVITE_HBS_PATH = "user/collaborator-app-invite.hbs";
exports.USER_ADMIN_REVOKED_HBS_PATH = "user/admin-revoked.hbs";
exports.USER_OWNERSHIP_TRANSFERRED_HBS_PATH = "user/ownership-transferred.hbs";
exports.USER_MERGE_USERS_REQUEST_HBS_PATH = "user/merge-users-request.hbs";
exports.USER_INVITATION_FIRST_REMINDER_HBS_PATH = "user/invitation-first-reminder.hbs";
exports.USER_INVITATION_SECOND_REMINDER_HBS_PATH = "user/invitation-second-reminder.hbs";
exports.USER_INVITATION_REFUSED_HBS_PATH = "user/invitation-refused.hbs";
exports.USER_NPO_STARTER_INVITATION_HBS_PATH = "user/npo-starter-invitation.hbs";
exports.USER_FAILED_PAD_ACH_HBS_PATH = "user/failed-pad-ach.hbs";
exports.USER_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH = "user/failed-recurring-card-payment.hbs";
exports.USER_CARD_EXPIRING_HBS_PATH = "user/card-expiring.hbs";
exports.USER_DELETE_IMPORT_SUCCESS_HBS_PATH = "user/delete-import-success.hbs";
exports.USER_DELETE_IMPORT_ERROR_HBS_PATH = "user/delete-import-error.hbs";
exports.ORGANIZATION_PAGE_BUTTON_TEMPLATE_PATHS = new Set([
    exports.DONATION_HBS_PATH,
    exports.TICKETING_HBS_PATH,
    exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH,
    exports.FUNDRAISER_HBS_PATH,
    exports.TEAM_MEMBER_JOINED_HBS_PATH,
    exports.TRIBUTE_DONATION_HBS_PATH,
    exports.IMPACT_CHAIN_HBS_PATH,
    exports.NEWSLETTER_THANK_YOU_HBS_PATH,
    exports.AUCTION_WINNER_HBS_PATH,
    exports.AUCTION_NON_WINNER_HBS_PATH,
    exports.DAF_DONATION_HBS_PATH,
    exports.TRANSFER_IN_PROGRESS_HBS_PATH,
    exports.SEPA_DEBIT_NOTICE_HBS_PATH,
]);
exports.sendgridHtmlTemplate = {
    DAF_DONATION: {
        [locales_1.Locales.EN]: exports.DAF_DONATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.DAF_DONATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.DAF_DONATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.DAF_DONATION_HBS_PATH,
    },
    ORGANIZATION_DAF_TO_CONFIRM: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_DAF_TO_CONFIRM_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_DAF_TO_CONFIRM_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_DAF_TO_CONFIRM_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_DAF_TO_CONFIRM_HBS_PATH,
    },
    TICKETING_THANK_YOU_V2: {
        [locales_1.Locales.EN]: exports.TICKETING_HBS_PATH,
        [locales_1.Locales.FR]: exports.TICKETING_HBS_PATH,
        [locales_1.Locales.ES]: exports.TICKETING_HBS_PATH,
        [locales_1.Locales.DE]: exports.TICKETING_HBS_PATH,
    },
    SWEEPSTAKES_FREE_ENTRY_V2: {
        [locales_1.Locales.EN]: exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH,
        [locales_1.Locales.FR]: exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH,
        [locales_1.Locales.ES]: exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH,
        [locales_1.Locales.DE]: exports.SWEEPSTAKES_FREE_ENTRY_HBS_PATH,
    },
    DONATION_THANK_YOU_V2: {
        [locales_1.Locales.EN]: exports.DONATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.DONATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.DONATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.DONATION_HBS_PATH,
    },
    FUNDRAISER_THANK_YOU_V2: {
        [locales_1.Locales.EN]: exports.FUNDRAISER_HBS_PATH,
        [locales_1.Locales.FR]: exports.FUNDRAISER_HBS_PATH,
        [locales_1.Locales.ES]: exports.FUNDRAISER_HBS_PATH,
        [locales_1.Locales.DE]: exports.FUNDRAISER_HBS_PATH,
    },
    TEAM_MEMBER_JOINED_V2: {
        [locales_1.Locales.EN]: exports.TEAM_MEMBER_JOINED_HBS_PATH,
        [locales_1.Locales.FR]: exports.TEAM_MEMBER_JOINED_HBS_PATH,
        [locales_1.Locales.ES]: exports.TEAM_MEMBER_JOINED_HBS_PATH,
        [locales_1.Locales.DE]: exports.TEAM_MEMBER_JOINED_HBS_PATH,
    },
    CAMPAIGN_PARTICIPATION_V2: {
        [locales_1.Locales.EN]: exports.CAMPAIGN_PARTICIPATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.CAMPAIGN_PARTICIPATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.CAMPAIGN_PARTICIPATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.CAMPAIGN_PARTICIPATION_HBS_PATH,
    },
    SEPA_DEBIT_NOTICE: {
        [locales_1.Locales.EN]: exports.SEPA_DEBIT_NOTICE_HBS_PATH,
        [locales_1.Locales.FR]: exports.SEPA_DEBIT_NOTICE_HBS_PATH,
        [locales_1.Locales.ES]: exports.SEPA_DEBIT_NOTICE_HBS_PATH,
        [locales_1.Locales.DE]: exports.SEPA_DEBIT_NOTICE_HBS_PATH,
    },
    TRANSFER_IN_PROGRESS_V2: {
        [locales_1.Locales.EN]: exports.TRANSFER_IN_PROGRESS_HBS_PATH,
        [locales_1.Locales.FR]: exports.TRANSFER_IN_PROGRESS_HBS_PATH,
        [locales_1.Locales.ES]: exports.TRANSFER_IN_PROGRESS_HBS_PATH,
        [locales_1.Locales.DE]: exports.TRANSFER_IN_PROGRESS_HBS_PATH,
    },
    AUCTION_WINNER_V2: {
        [locales_1.Locales.EN]: exports.AUCTION_WINNER_HBS_PATH,
        [locales_1.Locales.FR]: exports.AUCTION_WINNER_HBS_PATH,
        [locales_1.Locales.ES]: exports.AUCTION_WINNER_HBS_PATH,
        [locales_1.Locales.DE]: exports.AUCTION_WINNER_HBS_PATH,
    },
    AUCTION_NON_WINNER_V2: {
        [locales_1.Locales.EN]: exports.AUCTION_NON_WINNER_HBS_PATH,
        [locales_1.Locales.FR]: exports.AUCTION_NON_WINNER_HBS_PATH,
        [locales_1.Locales.ES]: exports.AUCTION_NON_WINNER_HBS_PATH,
        [locales_1.Locales.DE]: exports.AUCTION_NON_WINNER_HBS_PATH,
    },
    BID_SUBMITTED_V2: {
        [locales_1.Locales.EN]: exports.AUCTION_BID_PLACED_HBS_PATH,
        [locales_1.Locales.FR]: exports.AUCTION_BID_PLACED_HBS_PATH,
        [locales_1.Locales.ES]: exports.AUCTION_BID_PLACED_HBS_PATH,
        [locales_1.Locales.DE]: exports.AUCTION_BID_PLACED_HBS_PATH,
    },
    BUYER_OUTBID_V2: {
        [locales_1.Locales.EN]: exports.AUCTION_OUTBID_HBS_PATH,
        [locales_1.Locales.FR]: exports.AUCTION_OUTBID_HBS_PATH,
        [locales_1.Locales.ES]: exports.AUCTION_OUTBID_HBS_PATH,
        [locales_1.Locales.DE]: exports.AUCTION_OUTBID_HBS_PATH,
    },
    AUCTION_BUYER_BID_CANCELLED_V2: {
        [locales_1.Locales.EN]: exports.AUCTION_BID_CANCELLED_HBS_PATH,
        [locales_1.Locales.FR]: exports.AUCTION_BID_CANCELLED_HBS_PATH,
        [locales_1.Locales.ES]: exports.AUCTION_BID_CANCELLED_HBS_PATH,
        [locales_1.Locales.DE]: exports.AUCTION_BID_CANCELLED_HBS_PATH,
    },
    BUYER_NEW_TOP_BIDDER_AFTER_CANCELLATION_V2: {
        [locales_1.Locales.EN]: exports.AUCTION_NEW_TOP_BIDDER_HBS_PATH,
        [locales_1.Locales.FR]: exports.AUCTION_NEW_TOP_BIDDER_HBS_PATH,
        [locales_1.Locales.ES]: exports.AUCTION_NEW_TOP_BIDDER_HBS_PATH,
        [locales_1.Locales.DE]: exports.AUCTION_NEW_TOP_BIDDER_HBS_PATH,
    },
    INVITE_ACCOUNTANT: {
        [locales_1.Locales.EN]: "invitation/invite-accountant-en.html",
        [locales_1.Locales.FR]: "invitation/invite-accountant-fr.html",
        [locales_1.Locales.ES]: "invitation/invite-accountant-en.html",
        [locales_1.Locales.DE]: "invitation/invite-accountant-de.html",
    },
    INVITE_BOARD_MEMBER: {
        [locales_1.Locales.EN]: "invitation/invite-board-member-en.html",
        [locales_1.Locales.FR]: "invitation/invite-board-member-fr.html",
        [locales_1.Locales.ES]: "invitation/invite-board-member-en.html",
        [locales_1.Locales.DE]: "invitation/invite-board-member-de.html",
    },
    EXPIRING_MEMBERSHIP_V2: {
        [locales_1.Locales.EN]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
        [locales_1.Locales.FR]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
        [locales_1.Locales.ES]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
        [locales_1.Locales.DE]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
    },
    AUTO_RENEWAL_V2: {
        [locales_1.Locales.EN]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
        [locales_1.Locales.FR]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
        [locales_1.Locales.ES]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
        [locales_1.Locales.DE]: exports.MEMBERSHIP_RENEWAL_HBS_PATH,
    },
    DONATION_AUTO_RENEWAL_V2: {
        [locales_1.Locales.EN]: exports.DONATION_RENEWAL_HBS_PATH,
        [locales_1.Locales.FR]: exports.DONATION_RENEWAL_HBS_PATH,
        [locales_1.Locales.ES]: exports.DONATION_RENEWAL_HBS_PATH,
        [locales_1.Locales.DE]: exports.DONATION_RENEWAL_HBS_PATH,
    },
    TICKETING_REMINDER_V2: {
        [locales_1.Locales.EN]: exports.REMINDER_TICKETING_HBS_PATH,
        [locales_1.Locales.FR]: exports.REMINDER_TICKETING_HBS_PATH,
        [locales_1.Locales.ES]: exports.REMINDER_TICKETING_HBS_PATH,
        [locales_1.Locales.DE]: exports.REMINDER_TICKETING_HBS_PATH,
    },
    ORGANIZATION_ATTENDEE_CANCELLATION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ATTENDEE_CANCELLATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ATTENDEE_CANCELLATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ATTENDEE_CANCELLATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ATTENDEE_CANCELLATION_HBS_PATH,
    },
    ORGANIZATION_REFUND_REQUEST_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_REFUND_REQUEST_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_REFUND_REQUEST_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_REFUND_REQUEST_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_REFUND_REQUEST_HBS_PATH,
    },
    GUEST_WEB_BASED_TICKET_V2: {
        [locales_1.Locales.EN]: exports.GUEST_TICKET_HBS_PATH,
        [locales_1.Locales.FR]: exports.GUEST_TICKET_HBS_PATH,
        [locales_1.Locales.ES]: exports.GUEST_TICKET_HBS_PATH,
        [locales_1.Locales.DE]: exports.GUEST_TICKET_HBS_PATH,
    },
    BUYER_GUEST_INFO_UPDATED_V2: {
        [locales_1.Locales.EN]: exports.GUEST_INFO_UPDATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.GUEST_INFO_UPDATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.GUEST_INFO_UPDATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.GUEST_INFO_UPDATED_HBS_PATH,
    },
    DONATION_TRIBUTE_V2: {
        [locales_1.Locales.EN]: exports.TRIBUTE_DONATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.TRIBUTE_DONATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.TRIBUTE_DONATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.TRIBUTE_DONATION_HBS_PATH,
    },
    IMPACT_CHAIN_DONATION_V2: {
        [locales_1.Locales.EN]: exports.IMPACT_CHAIN_HBS_PATH,
        [locales_1.Locales.FR]: exports.IMPACT_CHAIN_HBS_PATH,
        [locales_1.Locales.ES]: exports.IMPACT_CHAIN_HBS_PATH,
        [locales_1.Locales.DE]: exports.IMPACT_CHAIN_HBS_PATH,
    },
    NOTE_REMINDER: {
        [locales_1.Locales.EN]: "note-reminder/note-reminder-en.html",
        [locales_1.Locales.FR]: "note-reminder/note-reminder-fr.html",
        [locales_1.Locales.ES]: "note-reminder/note-reminder-en.html",
        [locales_1.Locales.DE]: "note-reminder/note-reminder-de.html",
    },
    READY_FOR_PICKUP_V2: {
        [locales_1.Locales.EN]: exports.READY_FOR_PICKUP_HBS_PATH,
        [locales_1.Locales.FR]: exports.READY_FOR_PICKUP_HBS_PATH,
        [locales_1.Locales.ES]: exports.READY_FOR_PICKUP_HBS_PATH,
        [locales_1.Locales.DE]: exports.READY_FOR_PICKUP_HBS_PATH,
    },
    ORDER_SHIPPED_V2: {
        [locales_1.Locales.EN]: exports.ORDER_SHIPPED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORDER_SHIPPED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORDER_SHIPPED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORDER_SHIPPED_HBS_PATH,
    },
    ORGANIZATION_TICKETING_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_TICKETING_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_TICKETING_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_TICKETING_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_TICKETING_CREATED_HBS_PATH,
    },
    ORGANIZATION_AUCTION_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_AUCTION_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_AUCTION_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_AUCTION_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_AUCTION_CREATED_HBS_PATH,
    },
    ORGANIZATION_BANK_ACCOUNT_UPDATE_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_BANK_ACCOUNT_UPDATE_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_BANK_ACCOUNT_UPDATE_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_BANK_ACCOUNT_UPDATE_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_BANK_ACCOUNT_UPDATE_HBS_PATH,
    },
    ORGANIZATION_PAYOUT_PAUSED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_PAYOUT_PAUSED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_PAYOUT_PAUSED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_PAYOUT_PAUSED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_PAYOUT_PAUSED_HBS_PATH,
    },
    ORGANIZATION_PAYOUT_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_PAYOUT_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_PAYOUT_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_PAYOUT_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_PAYOUT_CREATED_HBS_PATH,
    },
    ORGANIZATION_NEGATIVE_PAYOUT_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED_HBS_PATH,
    },
    ORGANIZATION_PAYOUT_FAILED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_PAYOUT_FAILED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_PAYOUT_FAILED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_PAYOUT_FAILED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_PAYOUT_FAILED_HBS_PATH,
    },
    ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED_HBS_PATH,
    },
    ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
    },
    ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE_HBS_PATH,
    },
    ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE_HBS_PATH,
    },
    ORGANIZATION_EXPORT_COMPLETED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_EXPORT_COMPLETED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_EXPORT_COMPLETED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_EXPORT_COMPLETED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_EXPORT_COMPLETED_HBS_PATH,
    },
    ORGANIZATION_IMPORT_COMPLETED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_IMPORT_COMPLETED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_IMPORT_COMPLETED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_IMPORT_COMPLETED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_IMPORT_COMPLETED_HBS_PATH,
    },
    ORGANIZATION_IMPORT_FAILED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_IMPORT_FAILED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_IMPORT_FAILED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_IMPORT_FAILED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_IMPORT_FAILED_HBS_PATH,
    },
    ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED_HBS_PATH,
    },
    ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_CONNECTED_BANK_ACCOUNT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK_HBS_PATH,
    },
    ORGANIZATION_STRIPE_INFORMATION_REQUIRED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED_HBS_PATH,
    },
    ORGANIZATION_STRIPE_RISK_REVIEW_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_STRIPE_RISK_REVIEW_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_STRIPE_RISK_REVIEW_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_STRIPE_RISK_REVIEW_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_STRIPE_RISK_REVIEW_HBS_PATH,
    },
    ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED_HBS_PATH,
    },
    ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER_HBS_PATH,
    },
    ORGANIZATION_FAILED_PAD_ACH_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_FAILED_PAD_ACH_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_FAILED_PAD_ACH_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_FAILED_PAD_ACH_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_FAILED_PAD_ACH_HBS_PATH,
    },
    ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED_HBS_PATH,
    },
    ORGANIZATION_CUSTOM_DOMAIN_FAILED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED_HBS_PATH,
    },
    ORGANIZATION_WEBHOOK_AUTO_DISABLED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED_HBS_PATH,
    },
    ORGANIZATION_REFERRAL_DURING_SIGN_UP_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP_HBS_PATH,
    },
    ORGANIZATION_REFERRAL_DURING_ONBOARDING_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING_HBS_PATH,
    },
    ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION_HBS_PATH,
    },
    ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT_HBS_PATH,
    },
    ORGANIZATION_FIRST_PAYMENT_RECEIVED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED_HBS_PATH,
    },
    ORGANIZATION_PAST_DUE_SUBSCRIPTION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION_HBS_PATH,
    },
    ORGANIZATION_TIPS_UPCOMING_EVENT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_TIPS_UPCOMING_EVENT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_TIPS_UPCOMING_EVENT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_TIPS_UPCOMING_EVENT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_TIPS_UPCOMING_EVENT_HBS_PATH,
    },
    ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT_HBS_PATH,
    },
    ORGANIZATION_AUCTION_CLOSED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_AUCTION_CLOSED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_AUCTION_CLOSED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_AUCTION_CLOSED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_AUCTION_CLOSED_HBS_PATH,
    },
    ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED_HBS_PATH,
    },
    ORGANIZATION_AUCTION_FAILED_PAYMENT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_AUCTION_FAILED_PAYMENT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_AUCTION_FAILED_PAYMENT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_AUCTION_FAILED_PAYMENT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_AUCTION_FAILED_PAYMENT_HBS_PATH,
    },
    ORGANIZATION_SUPPORT_SERVER_ERROR_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_SUPPORT_SERVER_ERROR_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_SUPPORT_SERVER_ERROR_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_SUPPORT_SERVER_ERROR_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_SUPPORT_SERVER_ERROR_HBS_PATH,
    },
    ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION_HBS_PATH,
    },
    ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE_HBS_PATH,
    },
    NEWSLETTER_THANK_YOU_V2: {
        [locales_1.Locales.EN]: exports.NEWSLETTER_THANK_YOU_HBS_PATH,
        [locales_1.Locales.FR]: exports.NEWSLETTER_THANK_YOU_HBS_PATH,
        [locales_1.Locales.ES]: exports.NEWSLETTER_THANK_YOU_HBS_PATH,
        [locales_1.Locales.DE]: exports.NEWSLETTER_THANK_YOU_HBS_PATH,
    },
    ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP_HBS_PATH,
    },
    ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION_HBS_PATH,
    },
    ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION_HBS_PATH,
    },
    ORGANIZATION_ISSUING_CARD_ON_THE_WAY_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY_HBS_PATH,
    },
    ORGANIZATION_ISSUING_CARD_ACTIVATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ISSUING_CARD_ACTIVATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ISSUING_CARD_ACTIVATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ISSUING_CARD_ACTIVATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ISSUING_CARD_ACTIVATED_HBS_PATH,
    },
    ORGANIZATION_ISSUING_EXPENSE_FAILED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ISSUING_EXPENSE_FAILED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ISSUING_EXPENSE_FAILED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ISSUING_EXPENSE_FAILED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ISSUING_EXPENSE_FAILED_HBS_PATH,
    },
    ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED_HBS_PATH,
    },
    ORGANIZATION_ISSUING_REWARD_SUCCEEDED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED_HBS_PATH,
    },
    ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED_HBS_PATH,
    },
    ORGANIZATION_BENEFICIARY_ADDED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_BENEFICIARY_ADDED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_BENEFICIARY_ADDED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_BENEFICIARY_ADDED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_BENEFICIARY_ADDED_HBS_PATH,
    },
    ORGANIZATION_LOW_TREASURY_BALANCE_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_LOW_TREASURY_BALANCE_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_LOW_TREASURY_BALANCE_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_LOW_TREASURY_BALANCE_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_LOW_TREASURY_BALANCE_HBS_PATH,
    },
    ORGANIZATION_TREASURY_BETA_INVITATION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_TREASURY_BETA_INVITATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_TREASURY_BETA_INVITATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_TREASURY_BETA_INVITATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_TREASURY_BETA_INVITATION_HBS_PATH,
    },
    ORGANIZATION_RECEIVED_CREDIT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_RECEIVED_CREDIT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_RECEIVED_CREDIT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_RECEIVED_CREDIT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_RECEIVED_CREDIT_HBS_PATH,
    },
    ORGANIZATION_OUTBOUND_PAYMENT_POSTED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED_HBS_PATH,
    },
    ORGANIZATION_OUTBOUND_PAYMENT_FAILED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED_HBS_PATH,
    },
    ORGANIZATION_WEEKLY_VISITOR_REPORT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_WEEKLY_VISITOR_REPORT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_WEEKLY_VISITOR_REPORT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_WEEKLY_VISITOR_REPORT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_WEEKLY_VISITOR_REPORT_HBS_PATH,
    },
    ORGANIZATION_MONTHLY_VISITOR_REPORT_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_MONTHLY_VISITOR_REPORT_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_MONTHLY_VISITOR_REPORT_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_MONTHLY_VISITOR_REPORT_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_MONTHLY_VISITOR_REPORT_HBS_PATH,
    },
    ORGANIZATION_DISPUTE_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_DISPUTE_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_DISPUTE_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_DISPUTE_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_DISPUTE_CREATED_HBS_PATH,
    },
    ORGANIZATION_DISPUTE_CLOSED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_DISPUTE_CLOSED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_DISPUTE_CLOSED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_DISPUTE_CLOSED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_DISPUTE_CLOSED_HBS_PATH,
    },
    ORGANIZATION_RADAR_EARLY_FRAUD_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_RADAR_EARLY_FRAUD_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_RADAR_EARLY_FRAUD_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_RADAR_EARLY_FRAUD_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_RADAR_EARLY_FRAUD_HBS_PATH,
    },
    ORGANIZATION_INSUFFICIENT_CAPABILITIES_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES_HBS_PATH,
    },
    ORGANIZATION_TICKET_TRANSFERRED_TO_NEW_OCCURRENCE_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_TICKET_TRANSFERRED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_TICKET_TRANSFERRED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_TICKET_TRANSFERRED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_TICKET_TRANSFERRED_HBS_PATH,
    },
    ORGANIZATION_PAGE_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_PAGE_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_PAGE_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_PAGE_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_PAGE_CREATED_HBS_PATH,
    },
    ORGANIZATION_PAGE_PUBLISHED: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_PAGE_PUBLISHED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_PAGE_PUBLISHED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_PAGE_PUBLISHED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_PAGE_PUBLISHED_HBS_PATH,
    },
    DISPUTE_CREATED_CUSTOMER_V2: {
        [locales_1.Locales.EN]: exports.DISPUTE_CREATED_CUSTOMER_HBS_PATH,
        [locales_1.Locales.FR]: exports.DISPUTE_CREATED_CUSTOMER_HBS_PATH,
        [locales_1.Locales.ES]: exports.DISPUTE_CREATED_CUSTOMER_HBS_PATH,
        [locales_1.Locales.DE]: exports.DISPUTE_CREATED_CUSTOMER_HBS_PATH,
    },
    ORGANIZATION_DONATION_RECEIVED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_DONATION_RECEIVED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_DONATION_RECEIVED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_DONATION_RECEIVED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_DONATION_RECEIVED_HBS_PATH,
    },
    ORGANIZATION_RECURRING_DONATION_CANCELLED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_RECURRING_DONATION_CANCELLED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_RECURRING_DONATION_CANCELLED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_RECURRING_DONATION_CANCELLED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_RECURRING_DONATION_CANCELLED_HBS_PATH,
    },
    ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED_HBS_PATH,
    },
    ORGANIZATION_DONATION_FORM_CREATED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_DONATION_FORM_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_DONATION_FORM_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_DONATION_FORM_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_DONATION_FORM_CREATED_HBS_PATH,
    },
    SUBSCRIPTION_AMOUNT_UPDATED_DONOR_V2: {
        [locales_1.Locales.EN]: exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR_HBS_PATH,
        [locales_1.Locales.FR]: exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR_HBS_PATH,
        [locales_1.Locales.ES]: exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR_HBS_PATH,
        [locales_1.Locales.DE]: exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR_HBS_PATH,
    },
    SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_V2: {
        [locales_1.Locales.EN]: exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_HBS_PATH,
        [locales_1.Locales.FR]: exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_HBS_PATH,
        [locales_1.Locales.ES]: exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_HBS_PATH,
        [locales_1.Locales.DE]: exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR_HBS_PATH,
    },
    ORGANIZATION_ORDER_RECEIVED_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_ORDER_RECEIVED_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_ORDER_RECEIVED_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_ORDER_RECEIVED_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_ORDER_RECEIVED_HBS_PATH,
    },
    ORGANIZATION_SATISFACTION_SURVEY_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_SATISFACTION_SURVEY_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_SATISFACTION_SURVEY_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_SATISFACTION_SURVEY_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_SATISFACTION_SURVEY_HBS_PATH,
    },
    ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH_HBS_PATH,
    },
    ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION_HBS_PATH,
    },
    ORGANIZATION_MAILING_FEEDBACK_REQUEST_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST_HBS_PATH,
    },
    ORGANIZATION_EMAIL_STATS_READY_V2: {
        [locales_1.Locales.EN]: exports.ORGANIZATION_EMAIL_STATS_READY_HBS_PATH,
        [locales_1.Locales.FR]: exports.ORGANIZATION_EMAIL_STATS_READY_HBS_PATH,
        [locales_1.Locales.ES]: exports.ORGANIZATION_EMAIL_STATS_READY_HBS_PATH,
        [locales_1.Locales.DE]: exports.ORGANIZATION_EMAIL_STATS_READY_HBS_PATH,
    },
    RECEIPT_CANCELLED_DONOR_V2: {
        [locales_1.Locales.EN]: exports.RECEIPT_CANCELLED_DONOR_HBS_PATH,
        [locales_1.Locales.FR]: exports.RECEIPT_CANCELLED_DONOR_HBS_PATH,
        [locales_1.Locales.ES]: exports.RECEIPT_CANCELLED_DONOR_HBS_PATH,
        [locales_1.Locales.DE]: exports.RECEIPT_CANCELLED_DONOR_HBS_PATH,
    },
    MEMBERS_ONLY_NOT_ELIGIBLE_V2: {
        [locales_1.Locales.EN]: exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE_HBS_PATH,
        [locales_1.Locales.FR]: exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE_HBS_PATH,
        [locales_1.Locales.ES]: exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE_HBS_PATH,
        [locales_1.Locales.DE]: exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE_HBS_PATH,
    },
    MEMBER_MEMBERSHIP_CARD_V2: {
        [locales_1.Locales.EN]: exports.MEMBERSHIP_MEMBER_CARD_HBS_PATH,
        [locales_1.Locales.FR]: exports.MEMBERSHIP_MEMBER_CARD_HBS_PATH,
        [locales_1.Locales.ES]: exports.MEMBERSHIP_MEMBER_CARD_HBS_PATH,
        [locales_1.Locales.DE]: exports.MEMBERSHIP_MEMBER_CARD_HBS_PATH,
    },
    NEW_MEMBERSHIP_CARD_V2: {
        [locales_1.Locales.EN]: exports.MEMBERSHIP_NEW_CARD_DONOR_HBS_PATH,
        [locales_1.Locales.FR]: exports.MEMBERSHIP_NEW_CARD_DONOR_HBS_PATH,
        [locales_1.Locales.ES]: exports.MEMBERSHIP_NEW_CARD_DONOR_HBS_PATH,
        [locales_1.Locales.DE]: exports.MEMBERSHIP_NEW_CARD_DONOR_HBS_PATH,
    },
    INVOICE_REMINDER_DONOR_V2: {
        [locales_1.Locales.EN]: exports.INVOICE_REMINDER_DONOR_HBS_PATH,
        [locales_1.Locales.FR]: exports.INVOICE_REMINDER_DONOR_HBS_PATH,
        [locales_1.Locales.ES]: exports.INVOICE_REMINDER_DONOR_HBS_PATH,
        [locales_1.Locales.DE]: exports.INVOICE_REMINDER_DONOR_HBS_PATH,
    },
    USER_ASSISTANT_VERIFICATION_CODE_V2: {
        [locales_1.Locales.EN]: exports.USER_ASSISTANT_VERIFICATION_CODE_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_ASSISTANT_VERIFICATION_CODE_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_ASSISTANT_VERIFICATION_CODE_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_ASSISTANT_VERIFICATION_CODE_HBS_PATH,
    },
    USER_RESET_PASSWORD_V2: {
        [locales_1.Locales.EN]: exports.USER_RESET_PASSWORD_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_RESET_PASSWORD_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_RESET_PASSWORD_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_RESET_PASSWORD_HBS_PATH,
    },
    USER_EMAIL_VERIFICATION_V2: {
        [locales_1.Locales.EN]: exports.USER_EMAIL_VERIFICATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_EMAIL_VERIFICATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_EMAIL_VERIFICATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_EMAIL_VERIFICATION_HBS_PATH,
    },
    USER_EMAIL_CHANGED_V2: {
        [locales_1.Locales.EN]: exports.USER_EMAIL_CHANGED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_EMAIL_CHANGED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_EMAIL_CHANGED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_EMAIL_CHANGED_HBS_PATH,
    },
    USER_PASSWORD_CHANGED_V2: {
        [locales_1.Locales.EN]: exports.USER_PASSWORD_CHANGED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_PASSWORD_CHANGED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_PASSWORD_CHANGED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_PASSWORD_CHANGED_HBS_PATH,
    },
    USER_CONTACT_EMAIL_CHANGED_V2: {
        [locales_1.Locales.EN]: exports.USER_CONTACT_EMAIL_CHANGED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_CONTACT_EMAIL_CHANGED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_CONTACT_EMAIL_CHANGED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_CONTACT_EMAIL_CHANGED_HBS_PATH,
    },
    USER_EMAIL_CHANGE_CONFIRMED_V2: {
        [locales_1.Locales.EN]: exports.USER_EMAIL_CHANGE_CONFIRMED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_EMAIL_CHANGE_CONFIRMED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_EMAIL_CHANGE_CONFIRMED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_EMAIL_CHANGE_CONFIRMED_HBS_PATH,
    },
    USER_NEW_DEVICE_V2: {
        [locales_1.Locales.EN]: exports.USER_NEW_DEVICE_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_NEW_DEVICE_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_NEW_DEVICE_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_NEW_DEVICE_HBS_PATH,
    },
    USER_ORGANIZATION_CREATED_V2: {
        [locales_1.Locales.EN]: exports.USER_ORGANIZATION_CREATED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_ORGANIZATION_CREATED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_ORGANIZATION_CREATED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_ORGANIZATION_CREATED_HBS_PATH,
    },
    USER_ORGANIZATION_INVITATION_V2: {
        [locales_1.Locales.EN]: exports.USER_ORGANIZATION_INVITATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_ORGANIZATION_INVITATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_ORGANIZATION_INVITATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_ORGANIZATION_INVITATION_HBS_PATH,
    },
    USER_ADMIN_ADDED_V2: {
        [locales_1.Locales.EN]: exports.USER_ADMIN_ADDED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_ADMIN_ADDED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_ADMIN_ADDED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_ADMIN_ADDED_HBS_PATH,
    },
    USER_COLLABORATOR_APP_INVITE_V2: {
        [locales_1.Locales.EN]: exports.USER_COLLABORATOR_APP_INVITE_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_COLLABORATOR_APP_INVITE_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_COLLABORATOR_APP_INVITE_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_COLLABORATOR_APP_INVITE_HBS_PATH,
    },
    USER_ADMIN_REVOKED_V2: {
        [locales_1.Locales.EN]: exports.USER_ADMIN_REVOKED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_ADMIN_REVOKED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_ADMIN_REVOKED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_ADMIN_REVOKED_HBS_PATH,
    },
    USER_OWNERSHIP_TRANSFERRED_V2: {
        [locales_1.Locales.EN]: exports.USER_OWNERSHIP_TRANSFERRED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_OWNERSHIP_TRANSFERRED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_OWNERSHIP_TRANSFERRED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_OWNERSHIP_TRANSFERRED_HBS_PATH,
    },
    USER_MERGE_USERS_REQUEST_V2: {
        [locales_1.Locales.EN]: exports.USER_MERGE_USERS_REQUEST_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_MERGE_USERS_REQUEST_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_MERGE_USERS_REQUEST_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_MERGE_USERS_REQUEST_HBS_PATH,
    },
    USER_INVITATION_FIRST_REMINDER_V2: {
        [locales_1.Locales.EN]: exports.USER_INVITATION_FIRST_REMINDER_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_INVITATION_FIRST_REMINDER_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_INVITATION_FIRST_REMINDER_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_INVITATION_FIRST_REMINDER_HBS_PATH,
    },
    USER_INVITATION_SECOND_REMINDER_V2: {
        [locales_1.Locales.EN]: exports.USER_INVITATION_SECOND_REMINDER_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_INVITATION_SECOND_REMINDER_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_INVITATION_SECOND_REMINDER_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_INVITATION_SECOND_REMINDER_HBS_PATH,
    },
    USER_INVITATION_REFUSED_V2: {
        [locales_1.Locales.EN]: exports.USER_INVITATION_REFUSED_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_INVITATION_REFUSED_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_INVITATION_REFUSED_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_INVITATION_REFUSED_HBS_PATH,
    },
    USER_NPO_STARTER_INVITATION_V2: {
        [locales_1.Locales.EN]: exports.USER_NPO_STARTER_INVITATION_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_NPO_STARTER_INVITATION_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_NPO_STARTER_INVITATION_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_NPO_STARTER_INVITATION_HBS_PATH,
    },
    USER_FAILED_PAD_ACH_V2: {
        [locales_1.Locales.EN]: exports.USER_FAILED_PAD_ACH_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_FAILED_PAD_ACH_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_FAILED_PAD_ACH_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_FAILED_PAD_ACH_HBS_PATH,
    },
    USER_FAILED_RECURRING_CARD_PAYMENT_V2: {
        [locales_1.Locales.EN]: exports.USER_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_FAILED_RECURRING_CARD_PAYMENT_HBS_PATH,
    },
    USER_CARD_EXPIRING_V2: {
        [locales_1.Locales.EN]: exports.USER_CARD_EXPIRING_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_CARD_EXPIRING_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_CARD_EXPIRING_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_CARD_EXPIRING_HBS_PATH,
    },
    USER_DELETE_IMPORT_SUCCESS_V2: {
        [locales_1.Locales.EN]: exports.USER_DELETE_IMPORT_SUCCESS_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_DELETE_IMPORT_SUCCESS_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_DELETE_IMPORT_SUCCESS_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_DELETE_IMPORT_SUCCESS_HBS_PATH,
    },
    USER_DELETE_IMPORT_ERROR_V2: {
        [locales_1.Locales.EN]: exports.USER_DELETE_IMPORT_ERROR_HBS_PATH,
        [locales_1.Locales.FR]: exports.USER_DELETE_IMPORT_ERROR_HBS_PATH,
        [locales_1.Locales.ES]: exports.USER_DELETE_IMPORT_ERROR_HBS_PATH,
        [locales_1.Locales.DE]: exports.USER_DELETE_IMPORT_ERROR_HBS_PATH,
    },
};
